"use client";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import Technologies from "@/components/Technologies";
import Philosophy from "@/components/Philosophy";
import Architecture from "@/components/Architecture";
import Projects from "@/components/Projects";
import GithubSection from "@/components/GithubSection";
import Blog from "@/components/Blog";
import Testimonials from "@/components/Testimonials";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="relative">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Technologies />
        <Philosophy />
        <Architecture />
        <Projects />
        <GithubSection />
        <Blog />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
